function getMetaContent(name) {
  const meta = document.querySelector(`meta[name="${name}"]`)
  return meta && meta.content
}

const wpApiBaseUrlMeta = getMetaContent('wp-api-base-url')
export const WP_API_BASE = wpApiBaseUrlMeta || '/wp-json/pch/v2/rlty/'
